export default __webpack_public_path__ + "static/goldpiercingdust-e204c5ce0a5c301e746e78465e9cda0c.png";